<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="create-content-notification-reminder-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
            </button>

            <h4 class="modal-title">
              Create Reminder
            </h4>
          </div>

          <div class="modal-body">
            <TextareaFormGroup
                v-model="data.text"
                name="text"
                label="Text"
                :error="getError('text')"
            />

            <SelectFormGroup
                v-model="data.priority"
                name="priority"
                label="Priority"
                :error="getError('priority')"
                :options="[{value: 'high', label: 'High'}, {value: 'medium', label: 'Medium'}, {value: 'low', label: 'Low'}]"
            />

            <DateFormGroup
                v-model="data.remind_at"
                name="remind_at"
                label="Remind At"
                :error="getError('remind_at')"
                format="DD.MM.YYYY HH:mm"
                original-format="YYYY-MM-DD HH:mm"
            />
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>

            <button type="submit" class="btn btn-black">
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import store from '@/store'
import Errors from '@/mixins/Errors'
import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'
import DateFormGroup from '@/vendor/forms/FormGroups/Block/Date'
import TextareaFormGroup from '@/vendor/forms/FormGroups/Block/Textarea'

export default {
  components: {DateFormGroup, SelectFormGroup ,TextareaFormGroup},

  mixins: [Errors],

  props: {
    contentNotification: {
      required: true
    },
  },

  data() {
    return {
      data: {}
    }
  },

  watch: {
    contentNotification() {
      this.data = {
        text: this.contentNotification.attributes.content_url
      }
    }
  },

  mounted() {
    this.listenForClose()
  },

  methods: {
    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    submit() {
      http.post('/api/v2/reminders', {
        ...this.data,
        subject_id: this.contentNotification.attributes.company_id,
        subject_type: 'companies',
        remind_at: this.data.remind_at + ':00',
        portals: [{id:this.contentNotification.attributes.portal_id}],
        user_id: store.user.id,
      })
          .then(() => {
            notify.success('The reminder was saved')

            this.$emit('created')

            $(this.$el).modal('hide')
          })
          .catch(this.catchValidationErrors)
    },

    reset() {
      this.errors = {}

      this.data = {
        text: this.contentNotification.attributes.content_url
      }
    }
  }
}
</script>
